import { render, staticRenderFns } from "./preview-gas-db-record-dialog.component.vue?vue&type=template&id=fb086438"
import script from "./preview-gas-db-record-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./preview-gas-db-record-dialog.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb086438')) {
      api.createRecord('fb086438', component.options)
    } else {
      api.reload('fb086438', component.options)
    }
    module.hot.accept("./preview-gas-db-record-dialog.component.vue?vue&type=template&id=fb086438", function () {
      api.rerender('fb086438', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin-panel/gas-db/preview-gas-db-record-dialog/preview-gas-db-record-dialog.component.vue"
export default component.exports